import CountryStateService from 'src/modules/countryState/countryStateService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'COUNTRYSTATE_FORM';

const countryStateFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: countryStateFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await CountryStateService.find(id);
      }

      dispatch({
        type: countryStateFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: countryStateFormActions.INIT_ERROR,
      });

      getHistory().push('/country-state');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: countryStateFormActions.CREATE_STARTED,
      });

      await CountryStateService.create(values);

      dispatch({
        type: countryStateFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.countryState.create.success'),
      );

      getHistory().push('/country-state');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: countryStateFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: countryStateFormActions.UPDATE_STARTED,
      });

      await CountryStateService.update(id, values);

      dispatch({
        type: countryStateFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.countryState.update.success'),
      );

      getHistory().push('/country-state');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: countryStateFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default countryStateFormActions;
